import React, { useState } from "react";
import {
	ErrorDialogProviderProps
} from "src/components/common/dialogs/errorDialog/ErrorDialogProvider.tsx";
import { MessageDialog } from "./MessageDialog";
import { Typography } from "@mui/material";

export const MessageDialogContext = React.createContext<ShowMessageDialogFunc | undefined>(
	undefined
);

export type ShowMessageDialogFunc = (params: MessageDialogParams) => void

export interface MessageDialogParams {
	title?: string;
	content: string;
}

export const MessageDialogProvider = ({ children }: ErrorDialogProviderProps) => {
	const [messageParams, setMessageParams] = useState<MessageDialogParams | undefined>(undefined);
	return <>
		<MessageDialogContext.Provider value={setMessageParams}>
			{children}
		</MessageDialogContext.Provider>
		{messageParams &&
			<MessageDialog
				size={"sm"}
				onClose={() => {
					setMessageParams(undefined);
				}}
				onClickOk={() => {
					setMessageParams(undefined);
				}}
				title={messageParams.title ?? ""}
			>
				<Typography sx={{
					marginX: "1rem"
				}}>
					{messageParams.content}
				</Typography>
			</MessageDialog>
		}
	</>;
};
